import { QueryClient } from '@tanstack/react-query';

var queryClient = new QueryClient();

export { queryClient };
